import {isInView, isOutOfView} from 'isinview';
import {waitUntil, TimeoutError} from 'async-wait-until';

if (!customElements.get('slideshow-component')) {
  class SlideshowComponent extends HTMLElement {
    constructor() {
      super();

      this.slideshow = this.querySelector('.splide');
      this.slideshowList = this.slideshow.querySelector('.splide__list');

      this.initSlideshow();     
    }

    initSlideshow() {
      this.options = JSON.parse(this.slideshow.dataset.options);

      // If video slides use the slide method instead of a looping carosel
      const videoSlides = this.slideshow.querySelectorAll('.splide__slide[data-type="video"]');
      if (videoSlides.length > 0) {
        this.options.type = 'slide';
        this.options.rewind = true;
      }

      if (this.options.size <= 1) {
        if (videoSlides.length > 0) {
          const videoSlide = this.slideshow.querySelector('.splide__slide')
          this.initSlideVideo(videoSlide);
        }
        return;
      };

      this.Splide = new theme.Splide(this.slideshow, this.options);

      this.Splide.on('moved', (index, prev, dest) => {
        let indexId = index + 1;
        if (indexId < 10) {
          indexId = `0${indexId}`;
        }

        const destSlide = this.slideshow.querySelector(
          `#${this.Splide.root.id}-slide${indexId}`
        );
        const destSlideImage = destSlide.querySelector('.slide__image');
        this.slideshowList.style.height = `${destSlideImage.offsetHeight}px`;

        if (destSlide.getAttribute('data-type') === 'video') {
          this.initSlideVideo(destSlide);
        }
      });

      this.Splide.on('mounted', () => {
        this.onResize();

        const activeSlide = this.slideshow.querySelector(
          '.splide__slide.is-active'
        );
        if (activeSlide.getAttribute('data-type') === 'video') {
          this.initSlideVideo(activeSlide);
        }
      });

      this.Splide.mount();

      this.bindEditorEvents();
    }

    onResize() {
      this.slideshowResizeObserver = new ResizeObserver((entries) => {      
        const activeSlideImage = this.slideshow.querySelector(
          '.splide__slide.is-active .slide__image'
        );
        if ( this.Splide.state.is( theme.Splide.STATES.IDLE ) ) {
          this.slideshowList.style.height = `${activeSlideImage.offsetHeight}px`;
        }
      });

      this.slideshowResizeObserver.observe(this.slideshow);
    }

    loadYouTubeAPI() {
      if (window.YT !== undefined) {
        theme.youTubeApiStatus = 'ready';
      }
      if (
        theme.youTubeApiStatus !== 'loaded' ||
        theme.youTubeApiStatus !== 'ready'
      ) {
        const script = document.createElement('script');
        script.id = `youtube-iframe-api`;
        script.src = `https://www.youtube.com/iframe_api`;
        script.async = true;
        script.onload = async () => {
          await waitUntil(() => window.YT.Player !== undefined, {
            timeout: 10000,
          });
          theme.youTubeApiStatus = 'loaded';
        };
        document.body.append(script);
      }
    }

    async initSlideVideo(slide) {

      try {
        await waitUntil(() => theme.userInteraction === true, {
          timeout: 4000,
        });
      } catch (error) {
        if (error instanceof TimeoutError) {
          theme.userInteraction = true;
        }
      }

      if (slide.dataset.videoLoaded === 'true') return;

      if (theme.youTubeApiStatus !== 'loaded') {
        this.loadYouTubeAPI();
        await waitUntil(() => theme.youTubeApiStatus === 'loaded', { timeout: 10000 });
      }
      
      const videoSlideHTML = `<div class="slide__video absolute inset-0 z-20"></div>`;
      const slideContain = slide.querySelector('.slide__contain');
      slideContain.insertAdjacentHTML('beforeend', videoSlideHTML);

      const videoSlide = slide.querySelector('.slide__video');
      const videoId = slide.dataset.videoId;

      const videoSlideBackground = new theme.Vidim(videoSlide, {
        type: 'YouTube',
        src: videoId
      });

      videoSlideBackground.once('ready', function() {
        this.container.style.opacity = 0;
        this.play();

        // Play pause when in view
        const options = {
          threshold: 0.001,
        }

        isInView(slide, (target) => {
          videoSlideBackground.play();
        }, options);

        isOutOfView(
          slide,
          (target) => {
            videoSlideBackground.pause();
          },
          options
        );
      });

      videoSlideBackground.once('play', function(){
        const container = this.container;
        const showDelay = 200;
        window.setTimeout(function () {
          container.style.opacity = 1;
        }, showDelay);
      });

      slide.dataset.videoLoaded = 'true';
    }
 
    bindEditorEvents() {
      const {Autoplay} = this.Splide.Components;

      document.addEventListener('shopify:block:select', (event) => {
        const blockId = event.detail.blockId;
        const selectedBlock = this.slideshow.querySelector(
          `[data-block-id="${blockId}"]`
        );
        if (selectedBlock) {
          const slideIndex = Number(selectedBlock.dataset.slideIndex);
          this.Splide.go(slideIndex);
        }
      });

      document.addEventListener('shopify:section:select', (event) => {
        Autoplay.pause();
      });

      document.addEventListener('shopify:section:deselect', (event) => {
        Autoplay.play();
      });
    }
  }
  customElements.define('slideshow-component', SlideshowComponent);
}
